module.exports = __webpack_public_path__ + "static/media/software_development.aad01832.gif";